import Image from "next/image";

export default function InstitucionalHome() {
  return (
    <>
      <div className="rbt-banner-area rbt-banner-8 mt-40 lg-mt-0">
        <div className="container align-items-center ratio ratio-16x9">
          <iframe
            className="embed-responsive-item"
            src="https://www.youtube.com/embed/0GLFChdKAj4?si=NsePrNyb18Eff_K9&modestbranding=1&autohide=1&showinfo=0&controls=0"
            frameBorder={0}
            allow="accelerometer; autoplay; encrypted-media; gyroscope"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>

      <div className="rbt-banner-area rbt-banner-8 mt-40">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-10 offset-lg-1">
              <div className="content">
                <div className="inner text-center">
                  <h2>Plataforma de ensino médico certificada com cursos ministrados por profissionais qualificados</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="rbt-banner-area rbt-banner-8 mt-40">
        <div className="container  align-items-center p-0 my-5">
          <Image alt="Clinique Cursos" src="/novos/img/medicos.png" width="0" height="0" sizes="100vw" className="w-100 h-100 rounded" />
          <div className="profile-content rbt-shadow-box">
            <h3 className="text-center mt-5">Missão e Visão: Moldando o Futuro da Medicina</h3>
            <div className="row g-5 mt-5">
              <div className="col-lg-4">
                <h4>Missão</h4>
                <p className="mt--10 mb--20">
                  A missão da Clinique é proporcionar uma educação médica de excelência através de uma plataforma de ensino à distância inovadora e acessível. Buscamos capacitar
                  profissionais de saúde com conhecimentos atualizados e habilidades práticas, contribuindo para a melhoria da qualidade do atendimento médico em todo o país.
                </p>
              </div>
              <div className="col-lg-4">
                <h4>Visão</h4>
                <p className="mt--10 mb--20">
                  Nossa visão é ser reconhecida como a principal plataforma de educação médica à distância no Brasil e na América Latina até 2030. Aspiramos criar uma comunidade
                  global de profissionais de saúde conectados, promovendo a troca de conhecimentos e experiências que impulsionarão avanços significativos na prática médica.
                </p>
              </div>
              <div className="col-lg-4">
                <h4>Impacto</h4>
                <p className="mt--10 mb--20">
                  Ao democratizar o acesso à educação médica de qualidade, a Clinique visa reduzir as disparidades na formação de profissionais de saúde entre diferentes regiões.
                  Nosso objetivo é contribuir para a formação de médicos mais preparados e atualizados, resultando em um atendimento de saúde mais eficiente e humanizado em todo o
                  país.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="rbt-banner-area rbt-banner-8 mt-40">
        <div
          className="container profile-content rbt-shadow-box my-5 text-white"
          style={{ backgroundImage: `url(/novos/img/medica-tablet.png)`, backgroundColor: "#16546b", backgroundSize: "cover", backgroundRepeat: "no-repeat" }}
        >
          <div className="col-lg-6 p-5">
            <h2 className="text-white">Revolucionando o Ensino Médico à Distância</h2>
            <p>A Clinique surge como uma plataforma inovadora de ensino à distância na área da medicina, com o objetivo de transformar a educação médica no Brasil e no mundo.</p>

            <p>
              Fundada por um grupo de renomados médicos e educadores, a Clinique combina tecnologia de ponta com conteúdo acadêmico de alta qualidade para oferecer uma experiência
              de aprendizado única e eficaz.
            </p>

            <p>
              Nosso compromisso é democratizar o acesso ao conhecimento médico, permitindo que estudantes e profissionais de saúde de todas as regiões tenham acesso a uma formação
              de excelência, independentemente de sua localização geográfica.
            </p>

            <p>Com uma plataforma intuitiva e recursos pedagógicos inovadores, a Clinique está moldando o futuro da educação médica.</p>
          </div>
        </div>
      </div>
    </>
  );
}

